// import { t } from "@lingui/macro";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
// import SearchIcon from "@mui/icons-material/Search";
// import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   InputAdornment,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TextField,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { format, parseISO } from "date-fns";
// import { useCallback, useEffect, useMemo, useState } from "react";

// import { useAppContext } from "@/client/hooks/context";
// import {
//   downloadMyCertificate,
//   fetchMyCertificates,
//   type StudentCertificate,
// } from "@/client/services/certificates/certificates";

// const StyledTableContainer = styled(TableContainer)(() => ({
//   borderRadius: "12px 12px 0 0",
//   border: "1px solid #eaf0fb",
//   borderBottom: "none",
//   boxShadow: "0px 1px 4px rgba(0,0,0,0.06)",
//   maxHeight: "65vh",
//   overflowY: "auto",
// }));

// const StyledTableHead = styled(TableHead)(() => ({
//   position: "sticky",
//   top: 0,
//   zIndex: 2,
//   "& .MuiTableCell-root": {
//     backgroundColor: "#f7faff",
//     fontWeight: 700,
//     fontSize: "13px",
//     color: "#374151",
//     borderBottom: "2px solid #dde8fb",
//     whiteSpace: "nowrap",
//     padding: "10px 14px",
//   },
// }));

// const StyledTableRow = styled(TableRow)(() => ({
//   transition: "background-color 0.15s",
//   "&:hover": { backgroundColor: "#f0f6ff" },
//   "&:last-child .MuiTableCell-root": { borderBottom: "none" },
//   "& .MuiTableCell-root": {
//     fontSize: "13px",
//     color: "#374151",
//     borderBottom: "1px solid #eaf0fb",
//     padding: "10px 14px",
//   },
// }));

// const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

// const formatIssueDate = (value: string) => {
//   if (!value) return "--";
//   try {
//     return format(parseISO(value), "MMM dd, yyyy");
//   } catch {
//     return "--";
//   }
// };

// const MyCertificatesPage = () => {
//   const { loading, setLoading, reloading } = useAppContext();
//   const [certificates, setCertificates] = useState<StudentCertificate[]>([]);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [downloadingId, setDownloadingId] = useState<string | null>(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await fetchMyCertificates();
//       setCertificates(data);
//     } catch (error) {
//       console.error(error);
//       setCertificates([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [setLoading]);

//   useEffect(() => {
//     void fetchData();
//   }, [fetchData, reloading]);

//   const filteredRows = useMemo(() => {
//     const query = search.trim().toLowerCase();
//     if (!query) return certificates;

//     return certificates.filter((cert) => {
//       const haystack = [
//         cert.certificateNumber,
//         cert.recipientName,
//         cert.courseOrEventName,
//         cert.metadata?.rollNumber,
//         cert.metadata?.email,
//         cert.metadata?.branch,
//       ]
//         .filter(Boolean)
//         .join(" ")
//         .toLowerCase();

//       return haystack.includes(query);
//     });
//   }, [certificates, search]);

//   const paginatedRows = useMemo(() => {
//     const start = page * rowsPerPage;
//     return filteredRows.slice(start, start + rowsPerPage);
//   }, [filteredRows, page, rowsPerPage]);

//   const handleDownload = async (cert: StudentCertificate) => {
//     setDownloadingId(cert.certificateNumber);
//     try {
//       await downloadMyCertificate(cert.certificateNumber, cert.originalFileName);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setDownloadingId(null);
//     }
//   };

//   return (
//     <Box>
//       <Box sx={{ display: "flex", alignItems: "flex-end", mb: 1.5 }}>
//         <Box
//           sx={{
//             px: 2,
//             py: 1,
//             fontSize: "15px",
//             fontWeight: 700,
//             color: "primary.main",
//             mb: "-2px",
//             userSelect: "none",
//           }}
//         >
//           {t`My Certificates`}
//         </Box>
//       </Box>

//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1.5,
//           mb: 1.5,
//           px: 2,
//           py: 1.5,
//           backgroundColor: "#f7faff",
//           borderRadius: "12px",
//           border: "1px solid #dde8fb",
//         }}
//       >
//         <TextField
//           size="small"
//           placeholder={t`Search certificate number, course, branch...`}
//           value={search}
//           onChange={(e) => {
//             setSearch(e.target.value);
//             setPage(0);
//           }}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ fontSize: 15, color: "text.disabled" }} />
//               </InputAdornment>
//             ),
//             sx: { fontSize: "12px", borderRadius: "8px", bgcolor: "#fff" },
//           }}
//           sx={{
//             flex: 1,
//             maxWidth: 360,
//             "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
//             "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
//           }}
//         />
//       </Box>

//       {loading ? (
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             py: 8,
//             gap: 2,
//           }}
//         >
//           <CircularProgress size={36} />
//           <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
//             {t`Loading certificates...`}
//           </Typography>
//         </Box>
//       ) : filteredRows.length === 0 ? (
//         <Box
//           sx={{
//             textAlign: "center",
//             py: 8,
//             px: 2,
//             borderRadius: "12px",
//             border: "1px dashed #dde8fb",
//             bgcolor: "#fafcff",
//           }}
//         >
//           <WorkspacePremiumOutlinedIcon sx={{ fontSize: 48, color: "#90caf9", mb: 1.5 }} />
//           <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
//             {search.trim()
//               ? t`No certificates match your search.`
//               : t`No certificates found for your account yet.`}
//           </Typography>
//         </Box>
//       ) : (
//         <Paper
//           sx={{
//             borderRadius: "12px",
//             border: "1px solid #eaf0fb",
//             boxShadow: "0px 1px 4px rgba(0,0,0,0.06)",
//             overflow: "hidden",
//           }}
//         >
//           <StyledTableContainer>
//             <Table stickyHeader size="small" sx={{ tableLayout: "fixed", minWidth: 900 }}>
//               <StyledTableHead>
//                 <TableRow>
//                   <TableCell sx={{ width: "150px" }}>{t`Certificate No.`}</TableCell>
//                   <TableCell sx={{ width: "180px" }}>{t`Course / Event`}</TableCell>
//                   <TableCell sx={{ width: "140px" }}>{t`Recipient`}</TableCell>
//                   <TableCell align="center" sx={{ width: "120px" }}>{t`Roll Number`}</TableCell>
//                   <TableCell align="center" sx={{ width: "130px" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, justifyContent: "center" }}>
//                       <CalendarTodayIcon sx={{ fontSize: 13 }} />
//                       {t`Issue Date`}
//                     </Box>
//                   </TableCell>
//                   <TableCell align="center" sx={{ width: "110px" }}>{t`Actions`}</TableCell>
//                 </TableRow>
//               </StyledTableHead>
//               <TableBody>
//                 {paginatedRows.map((cert) => (
//                   <StyledTableRow key={cert._id}>
//                     <TableCell>
//                       <Typography sx={{ fontWeight: 600, fontSize: "12px", color: "primary.main" }}>
//                         {cert.certificateNumber}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Tooltip title={cert.courseOrEventName || "--"} placement="top">
//                         <Typography
//                           sx={{
//                             fontSize: "13px",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {cert.courseOrEventName || "--"}
//                         </Typography>
//                       </Tooltip>
//                     </TableCell>
//                     <TableCell>
//                       <Typography sx={{ fontSize: "13px" }}>{cert.recipientName}</Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Typography sx={{ fontSize: "13px" }}>
//                         {cert.metadata?.rollNumber || "--"}
//                       </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Typography sx={{ fontSize: "12px", color: "text.secondary", whiteSpace: "nowrap" }}>
//                         {formatIssueDate(cert.issueDate)}
//                       </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         startIcon={
//                           downloadingId === cert.certificateNumber ? (
//                             <CircularProgress size={14} />
//                           ) : (
//                             <DownloadOutlinedIcon sx={{ fontSize: 16 }} />
//                           )
//                         }
//                         disabled={downloadingId === cert.certificateNumber}
//                         onClick={() => void handleDownload(cert)}
//                         sx={{
//                           fontSize: "11px",
//                           textTransform: "none",
//                           borderColor: "#dde8fb",
//                           color: "primary.main",
//                           minWidth: 96,
//                         }}
//                       >
//                         {t`Download`}
//                       </Button>
//                     </TableCell>
//                   </StyledTableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </StyledTableContainer>

//           <TablePagination
//             component="div"
//             count={filteredRows.length}
//             page={page}
//             onPageChange={(_, nextPage) => setPage(nextPage)}
//             rowsPerPage={rowsPerPage}
//             onRowsPerPageChange={(event) => {
//               setRowsPerPage(parseInt(event.target.value, 10));
//               setPage(0);
//             }}
//             rowsPerPageOptions={PAGE_SIZE_OPTIONS}
//             sx={{
//               borderTop: "1px solid #eaf0fb",
//               ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
//                 fontSize: "12px",
//               },
//             }}
//           />
//         </Paper>
//       )}
//     </Box>
//   );
// };

// export default MyCertificatesPage;


import { t } from "@lingui/macro";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { format, parseISO } from "date-fns";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppContext } from "@/client/hooks/context";
import {
  downloadMyCertificate,
  fetchMyCertificates,
  previewMyCertificate,
  type StudentCertificate,
} from "@/client/services/certificates/certificates";

const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: "12px 12px 0 0",
  border: "1px solid #eaf0fb",
  borderBottom: "none",
  boxShadow: "0px 1px 4px rgba(0,0,0,0.06)",
  maxHeight: "65vh",
  overflowY: "auto",
}));

const StyledTableHead = styled(TableHead)(() => ({
  position: "sticky",
  top: 0,
  zIndex: 2,
  "& .MuiTableCell-root": {
    backgroundColor: "#f7faff",
    fontWeight: 700,
    fontSize: "13px",
    color: "#374151",
    borderBottom: "2px solid #dde8fb",
    whiteSpace: "nowrap",
    padding: "10px 14px",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  transition: "background-color 0.15s",
  "&:hover": { backgroundColor: "#f0f6ff" },
  "&:last-child .MuiTableCell-root": { borderBottom: "none" },
  "& .MuiTableCell-root": {
    fontSize: "13px",
    color: "#374151",
    borderBottom: "1px solid #eaf0fb",
    padding: "10px 14px",
  },
}));

const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

const formatIssueDate = (value: string) => {
  if (!value) return "--";
  try {
    return format(parseISO(value), "MMM dd, yyyy");
  } catch {
    return "--";
  }
};

// Detects whether a blob is a PDF or an image
const getBlobMimeType = (blob: Blob): "pdf" | "image" | "unknown" => {
  if (blob.type === "application/pdf") return "pdf";
  if (blob.type.startsWith("image/")) return "image";
  return "unknown";
};

const MyCertificatesPage = () => {
  const { loading, setLoading, reloading } = useAppContext();
  const [certificates, setCertificates] = useState<StudentCertificate[]>([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  // --- Preview state ---
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewCert, setPreviewCert] = useState<StudentCertificate | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [previewMimeType, setPreviewMimeType] = useState<"pdf" | "image" | "unknown">("unknown");
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchMyCertificates();
      setCertificates(data);
    } catch (error) {
      console.error(error);
      setCertificates([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    void fetchData();
  }, [fetchData, reloading]);

  // Cleanup object URL when the modal closes or a new one is set
  const revokePreviewUrl = useCallback(() => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
      setPreviewUrl(null);
    }
  }, [previewUrl]);

  const handleOpenPreview = async (cert: StudentCertificate) => {
    setPreviewCert(cert);
    setPreviewOpen(true);
    setPreviewLoading(true);
    setPreviewError(null);
    revokePreviewUrl();

    try {
      const blob = await previewMyCertificate(cert.certificateNumber);
      const mimeType = getBlobMimeType(blob);
      const url = URL.createObjectURL(blob);
      setPreviewMimeType(mimeType);
      setPreviewUrl(url);
    } catch (error) {
      console.error(error);
      setPreviewError(t`Failed to load certificate preview. Please try downloading it instead.`);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewLoading(false);
    setPreviewError(null);
    setPreviewCert(null);
    revokePreviewUrl();
  };

  const handleDownload = async (cert: StudentCertificate) => {
    setDownloadingId(cert.certificateNumber);
    try {
      await downloadMyCertificate(cert.certificateNumber, cert.originalFileName);
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadingId(null);
    }
  };

  const filteredRows = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return certificates;
    return certificates.filter((cert) => {
      const haystack = [
        cert.certificateNumber,
        cert.recipientName,
        cert.courseOrEventName,
        cert.metadata?.rollNumber,
        cert.metadata?.email,
        cert.metadata?.branch,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(query);
    });
  }, [certificates, search]);

  const paginatedRows = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredRows.slice(start, start + rowsPerPage);
  }, [filteredRows, page, rowsPerPage]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "flex-end", mb: 1.5 }}>
        <Box
          sx={{
            px: 2,
            py: 1,
            fontSize: "15px",
            fontWeight: 700,
            color: "primary.main",
            mb: "-2px",
            userSelect: "none",
          }}
        >
          {t`My Certificates`}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 1.5,
          px: 2,
          py: 1.5,
          backgroundColor: "#f7faff",
          borderRadius: "12px",
          border: "1px solid #dde8fb",
        }}
      >
        <TextField
          size="small"
          placeholder={t`Search certificate number, course, branch...`}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(0);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 15, color: "text.disabled" }} />
              </InputAdornment>
            ),
            sx: { fontSize: "12px", borderRadius: "8px", bgcolor: "#fff" },
          }}
          sx={{
            flex: 1,
            maxWidth: 360,
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
          }}
        />
      </Box>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 8,
            gap: 2,
          }}
        >
          <CircularProgress size={36} />
          <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
            {t`Loading certificates...`}
          </Typography>
        </Box>
      ) : filteredRows.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 8,
            px: 2,
            borderRadius: "12px",
            border: "1px dashed #dde8fb",
            bgcolor: "#fafcff",
          }}
        >
          <WorkspacePremiumOutlinedIcon sx={{ fontSize: 48, color: "#90caf9", mb: 1.5 }} />
          <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
            {search.trim()
              ? t`No certificates match your search.`
              : t`No certificates found for your account yet.`}
          </Typography>
        </Box>
      ) : (
        <Paper
          sx={{
            borderRadius: "12px",
            border: "1px solid #eaf0fb",
            boxShadow: "0px 1px 4px rgba(0,0,0,0.06)",
            overflow: "hidden",
          }}
        >
          <StyledTableContainer>
            <Table stickyHeader size="small" sx={{ tableLayout: "fixed", minWidth: 960 }}>
              <StyledTableHead>
                <TableRow>
                  <TableCell sx={{ width: "150px" }}>{t`Certificate No.`}</TableCell>
                  <TableCell sx={{ width: "180px" }}>{t`Course / Event`}</TableCell>
                  <TableCell sx={{ width: "140px" }}>{t`Recipient`}</TableCell>
                  <TableCell align="center" sx={{ width: "120px" }}>{t`Roll Number`}</TableCell>
                  <TableCell align="center" sx={{ width: "130px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        justifyContent: "center",
                      }}
                    >
                      <CalendarTodayIcon sx={{ fontSize: 13 }} />
                      {t`Issue Date`}
                    </Box>
                  </TableCell>
                  {/* Wider Actions column to fit both buttons */}
                  <TableCell align="center" sx={{ width: "150px" }}>{t`Actions`}</TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {paginatedRows.map((cert) => (
                  <StyledTableRow key={cert._id}>
                    <TableCell>
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "12px", color: "primary.main" }}
                      >
                        {cert.certificateNumber}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={cert.courseOrEventName || "--"} placement="top">
                        <Typography
                          sx={{
                            fontSize: "13px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {cert.courseOrEventName || "--"}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{ fontSize: "13px" }}>{cert.recipientName}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography sx={{ fontSize: "13px" }}>
                        {cert.metadata?.rollNumber || "--"}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography
                        sx={{ fontSize: "12px", color: "text.secondary", whiteSpace: "nowrap" }}
                      >
                        {formatIssueDate(cert.issueDate)}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.75 }}
                      >
                        {/* Preview eye icon button */}
                        <Tooltip title={t`Preview`} placement="top">
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => void handleOpenPreview(cert)}
                              sx={{
                                border: "1px solid #dde8fb",
                                borderRadius: "6px",
                                width: 30,
                                height: 30,
                                color: "primary.main",
                                bgcolor: "#fff",
                                "&:hover": {
                                  bgcolor: "#e8f0fe",
                                  borderColor: "#90caf9",
                                },
                              }}
                            >
                              <VisibilityOutlinedIcon sx={{ fontSize: 15 }} />
                            </IconButton>
                          </span>
                        </Tooltip>

                        {/* Download button */}
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={
                            downloadingId === cert.certificateNumber ? (
                              <CircularProgress size={14} />
                            ) : (
                              <DownloadOutlinedIcon sx={{ fontSize: 16 }} />
                            )
                          }
                          disabled={downloadingId === cert.certificateNumber}
                          onClick={() => void handleDownload(cert)}
                          sx={{
                            fontSize: "11px",
                            textTransform: "none",
                            borderColor: "#dde8fb",
                            color: "primary.main",
                            minWidth: 96,
                          }}
                        >
                          {t`Download`}
                        </Button>
                      </Box>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
          <TablePagination
            component="div"
            count={filteredRows.length}
            page={page}
            onPageChange={(_, nextPage) => setPage(nextPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={PAGE_SIZE_OPTIONS}
            sx={{
              borderTop: "1px solid #eaf0fb",
              ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                fontSize: "12px",
              },
            }}
          />
        </Paper>
      )}

      {/* ── Certificate Preview Dialog ── */}
      <Dialog
        open={previewOpen}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 8px 40px rgba(0,0,0,0.14)",
            height: "90vh",
          },
        }}
      >
        {/* Dialog header */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 1.5,
            borderBottom: "1px solid #eaf0fb",
            bgcolor: "#f7faff",
            flexShrink: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WorkspacePremiumOutlinedIcon sx={{ fontSize: 18, color: "primary.main" }} />
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#374151" }}>
                {previewCert?.courseOrEventName || t`Certificate Preview`}
              </Typography>
              {previewCert?.certificateNumber && (
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
                  #{previewCert.certificateNumber}
                  {previewCert.recipientName ? ` · ${previewCert.recipientName}` : ""}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Download from preview dialog */}
            {previewCert && (
              <Button
                size="small"
                variant="outlined"
                startIcon={
                  downloadingId === previewCert.certificateNumber ? (
                    <CircularProgress size={13} />
                  ) : (
                    <DownloadOutlinedIcon sx={{ fontSize: 15 }} />
                  )
                }
                disabled={downloadingId === previewCert.certificateNumber}
                onClick={() => void handleDownload(previewCert)}
                sx={{
                  fontSize: "11px",
                  textTransform: "none",
                  borderColor: "#dde8fb",
                  color: "primary.main",
                  minWidth: 96,
                }}
              >
                {t`Download`}
              </Button>
            )}
            <IconButton
              onClick={handleClosePreview}
              size="small"
              sx={{
                color: "text.secondary",
                "&:hover": { bgcolor: "#fee2e2", color: "#ef4444" },
              }}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* Dialog body */}
        <DialogContent
          sx={{
            p: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f0f4f8",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {previewLoading && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <CircularProgress size={40} />
              <Typography sx={{ color: "text.secondary", fontSize: "13px" }}>
                {t`Loading preview...`}
              </Typography>
            </Box>
          )}

          {!previewLoading && previewError && (
            <Box sx={{ textAlign: "center", px: 4 }}>
              <WorkspacePremiumOutlinedIcon
                sx={{ fontSize: 48, color: "#fca5a5", mb: 1.5 }}
              />
              <Typography sx={{ color: "#ef4444", fontSize: "13px", mb: 2 }}>
                {previewError}
              </Typography>
              {previewCert && (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<DownloadOutlinedIcon />}
                  onClick={() => void handleDownload(previewCert)}
                  sx={{ textTransform: "none" }}
                >
                  {t`Download instead`}
                </Button>
              )}
            </Box>
          )}

          {!previewLoading && !previewError && previewUrl && (
            <>
              {previewMimeType === "pdf" && (
                <Box
                  component="iframe"
                  src={`${previewUrl}#toolbar=0&navpanes=0`}
                  title={t`Certificate Preview`}
                  sx={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    display: "block",
                  }}
                />
              )}

              {previewMimeType === "image" && (
                <Box
                  component="img"
                  src={previewUrl}
                  alt={t`Certificate`}
                  sx={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    borderRadius: "8px",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                    m: 2,
                  }}
                />
              )}

              {previewMimeType === "unknown" && (
                <Box
                  component="iframe"
                  src={previewUrl}
                  title={t`Certificate Preview`}
                  sx={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    display: "block",
                  }}
                />
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default MyCertificatesPage;